/**
 * NavigationRegion3D registration: parser.
 */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseNavigationRegion3D } from './parser';
const navigationRegion3DRegistration = {
    typeName: 'NavigationRegion3D',
    parser: parseNavigationRegion3D,
};
nodeRegistry.register(navigationRegion3DRegistration);
//# sourceMappingURL=index.js.map